/**
 * 数据上报
 */
import Vue from 'vue'
// api 插件
import Report from '../plugins/report'
// api 配置
import config from './config'
Vue.use(Report)
// rest
export default new Report(Vue, config)



// WEBPACK FOOTER //
// ./src/report/index.js